import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { SPRINT_IN_TEMPLATE_DURATION_MULTIPLE } from 'components/organisms/sprint-planning/constants';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import {
  CreateSprintInProjectTemplate,
  createSprintInProjectTemplate,
} from '../../actions';
import { createProjectTemplateSprint } from '../../slices';
import { onCreateAndUpdateSprint } from '../date-shift';

function* createSprintInTemplateSaga(
  action: StoreActionProps<CreateSprintInProjectTemplate>,
) {
  try {
    const { payload } = action;

    yield put(createProjectTemplateSprint(payload));

    yield onCreateAndUpdateSprint({
      payload: {
        sprintId: payload?.sprint?.sprintId,
        payload: {
          startDay: 1,
          duration: SPRINT_IN_TEMPLATE_DURATION_MULTIPLE,
        },
      },
      type: '',
    });
  } catch (error) {
    logger.error('updateProjectTemplateSprint failed', { error });

    message.error('There was an error updating the sprint');
  }
}

export function* watchCreateSprintInProjectTemplateSaga(): Generator {
  yield takeLatest(
    createSprintInProjectTemplate.type,
    createSprintInTemplateSaga,
  );
}
